import * as React from 'react';
import TabChevron from '../../assets/icons/TabChevron.esm.js';
import classNames from 'classnames';
import { noop } from 'lodash';
import { useTabs } from '../NvTabs.hooks.esm.js';
import { useHorizontalScroll } from '../NvTabsHeader/NvTabsHeader.hooks.esm.js';
import styles from './NvTabsHeaderStandard.module.esm.js';

var NvTabsHeaderStandard = React.forwardRef(function (_a, navRef) {
    var tabs = _a.tabs, classes = _a.classes;
    var _b = useHorizontalScroll(navRef), scrollLeft = _b.scrollLeft, scrollRight = _b.scrollRight, scrollAtStart = _b.scrollAtStart, scrollEnd = _b.scrollEnd;
    var _c = useTabs(), isCurrentTab = _c.isCurrentTab, selectTab = _c.selectTab;
    return (React.createElement("div", { className: classNames(styles.tabContainer, classes === null || classes === void 0 ? void 0 : classes.contentHeader), "data-testid": "standard-wrapper" },
        React.createElement("button", { "aria-label": "Scroll tabs left", className: classNames(styles.arrow, styles.buttonLeft, scrollAtStart && styles.hidden), onClick: scrollLeft },
            React.createElement(TabChevron, { direction: "left" })),
        React.createElement("nav", { className: styles.tabHeaderRoot, ref: navRef },
            React.createElement("div", null, tabs.map(function (tab, tabIndex) {
                var _a;
                var isTabSelected = isCurrentTab(tab.id);
                return (React.createElement("button", { "aria-disabled": tab.disabled, "aria-selected": isTabSelected, className: classNames(styles.tab, classes === null || classes === void 0 ? void 0 : classes.tabHeader, (_a = {}, _a[styles.isSelected] = isTabSelected, _a)), "data-testid": "tab-header-std-".concat(tabIndex), key: tab.id, onClick: !tab.disabled ? function () { return selectTab(tab.id); } : noop, onKeyDown: function (e) { return (!['Space', 'Enter'].includes(e.key) || tab.disabled ? null : selectTab(tab.id)); }, role: "tab", tabIndex: 0 },
                    React.createElement("h3", { className: styles.tabText }, tab.text)));
            }))),
        React.createElement("button", { "aria-label": "Scroll tabs right", className: classNames(styles.arrow, styles.buttonRight, scrollEnd && styles.hidden), onClick: scrollRight },
            React.createElement(TabChevron, null))));
});
NvTabsHeaderStandard.displayName = 'NvTabsHeaderStandard';

export { NvTabsHeaderStandard };
//# sourceMappingURL=NvTabsHeaderStandard.esm.js.map
